import { User } from '@idea2app/ai-work-order-service';
import { clear } from 'idb-keyval';
import { HTTPClient } from 'koajax';
import { observable } from 'mobx';
import { BaseModel, persist, restore, toggle } from 'mobx-restful';
import { sleep } from 'web-utility';

export const baseURI =
    process.env.NODE_ENV === 'production'
        ? process.env.API_ROOT
        : 'http://localhost:8080';

export class UserModel extends BaseModel {
    @persist()
    @observable
    accessor session: User | undefined;

    restored = restore(this, 'User');

    client = new HTTPClient({ baseURI, responseType: 'json' }).use(
        ({ request }, next) => {
            const isSameDomain = baseURI.startsWith(
                new URL(request.path, baseURI).origin
            );
            if (isSameDomain && this.session)
                request.headers = {
                    ...request.headers,
                    Authorization: `Bearer ${this.session.token}`
                };

            return next();
        }
    );
    @toggle('uploading')
    async sendOTP(address: string) {
        await this.client.post(`user/session/email/${address}/OTP`);
    }

    @toggle('uploading')
    async signUp(email: string, password: string) {
        const { body } = await this.client.post<User>('user', {
            email,
            password
        });

        return body;
    }

    @toggle('uploading')
    async signIn(email: string, password: string) {
        const { body } = await this.client.post<User>('user/session', {
            email,
            password
        });

        return (this.session = body);
    }

    @toggle('uploading')
    async signOut() {
        this.session = undefined;
        await sleep();
        await clear();
        location.hash = '';
    }
}

export default new UserModel();
